export default value => `${value}em`;



// WEBPACK FOOTER //
// ./src/app/utils/em.js